<template>
  <div>
    <acceptance-user
      v-if="acceptance.acceptorTypeId === 1"
      :acceptance-id="acceptance.id"
      :acceptance-type="acceptance.type"
      :user="omit(acceptance.acceptor, ['confirmed_at', 'accessLevelType'])"
      type="default"></acceptance-user>
    <v-card v-else border>
      <div class="bg-grey-lighten-5 pa-3">
        <div class="d-flex align-center justify-space-between ga-3">
          <div class="d-flex align-center ga-5">
            <v-icon icon="mdi-office-building-outline" color="grey"></v-icon>
            <div class="font-weight-bold font-size-15">
              {{ acceptance.acceptor.name }}
            </div>
          </div>

          <v-btn
            v-if="canDelete"
            variant="plain"
            color="error"
            density="compact"
            size="small"
            :loading="$loading.isLoading(`acceptanceDelete_${acceptance.id}`)"
            @click="acceptanceDelete(acceptance.id)">
            <v-icon
              class="mr-2"
              icon="mdi-delete-outline font-size-11"></v-icon>
            <span>Видалити підрозділ</span>
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <div>
        <div
          v-for="(user, idx) in acceptance.acceptor.activeUsers"
          :key="user.id">
          <acceptance-user
            :acceptance-type="acceptance.acceptorType"
            :user="omit(user, ['confirmed_at', 'accessLevelType'])"
            type="departmentChild"></acceptance-user>

          <v-divider
            v-if="acceptance.acceptor.activeUsers.length - 1 > idx"></v-divider>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import AcceptanceUser from './AcceptanceUser.vue'
import { DocumentAcceptance } from '@/utils/types/document'
import { omit } from 'lodash'
import { useDocument } from '../../document'
import { useStore } from '@/plugins'
import { computed } from 'vue'

defineOptions({
  name: 'AcceptanceItem',
})

defineProps<{
  acceptance: DocumentAcceptance
}>()

const { acceptanceDelete, documentSource } = useDocument()
const store = useStore()
const userId = computed(() => store.state.user.userData?.id)

const canDelete = computed(() => {
  const allowedStatuses = ['draft', 'registered']
  return (
    allowedStatuses.includes(documentSource.status) &&
    documentSource.createdBy === userId.value
  )
})
</script>
